<div class="manage-team">
  <form
    [formGroup]="usersForm"
    class="mt-3 mb-3"
    fxLayout="row"
    fxLayoutAlign="space-between start"
  >
    <mat-form-field appearance="outline" class="w100 mr-2">
      <mat-label>Select existing user</mat-label>
      <input
        type="text"
        placeholder="Search and select an existing user"
        aria-label="User"
        matInput
        formControlName="user"
        [matAutocomplete]="userAutocomplete"
      />
      <mat-hint>You must select a user from the dropdown list</mat-hint>
      <mat-autocomplete
        #userAutocomplete="matAutocomplete"
        [displayWith]="displayUser"
      >
        @if (userLoading) {
          <mat-option disabled class="loading pt-3 pb-3"> </mat-option>
        }
        @if (noUsersFound()) {
          <mat-option disabled> No team found </mat-option>
        }
        @for (user of $any(usersAutocompleteData | async); track user.userId) {
          <mat-option [value]="user">
            {{ user.email }} | {{ user.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w100 mr-2">
      <mat-label>Select role</mat-label>
      <mat-select formControlName="role" placeholder="Select Role">
        @for (role of roles(); track role.roleId) {
          <mat-option [value]="role">{{ role.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <button
      mat-raised-button
      color="primary"
      class="mt-1"
      (click)="sendUserInvite()"
      [disabled]="usersForm.invalid"
    >
      Send invite
    </button>
  </form>
  <!-- <div
  *ngIf="usersForm.get('role')?.errors?.['invalidRole'] && (usersForm.touched || usersForm.dirty)"
  class="cross-validation-error-message alert alert-danger"
  >
  A contributor cannot access the HEAD version. Please add a version or select
  a different role.
</div> -->

  <hr />

  <h4>Invites sent</h4>
  <div class="invites">
    <mat-list>
      @for (invite of projectInvites(); track invite.inviteId) {
        <mat-list-item
          class="invite-item"
          [ngClass]="getInviteStatusClass(invite)"
        >
          <div matListItemTitle>
            {{ getDisplayName(invite.inviteeName, invite.inviteeHidden) }}
          </div>
          <div matListItemLine>
            Invited by:
            {{ getDisplayName(invite.inviterName, invite.inviterHidden) }},
            Invited at: {{ invite.invitedAt | date }}
          </div>
          <div matListItemLine>
            Role: {{ invite.roleName }}, Status: {{ invite.response }}
          </div>
          @if (invite.respondedAt) {
            <div matListItemLine>
              Responded at: {{ invite.respondedAt | date }}
            </div>
          }
          <button
            mat-icon-button
            class="list-button"
            (click)="manageUserInvitation(invite)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-list-item>
      }
    </mat-list>
  </div>
</div>
